import React from 'react';
import { NETWORKS } from '../utils/constants';

const PositionCard = ({ position }) => {
    const {
        tokenId,
        token0Symbol,
        token1Symbol,
        feeTier,
        deposited0,
        deposited1,
        fee0Earned,
        fee1Earned,
        pendingCake,
        priceLower,
        priceUpper,
        priceCurrent,
        isInMasterChef,
        valueUSD,
        token0,
        token1,
        liquidity,
        tickLower,
        tickUpper,
        currentTick,
        token0PriceUSD,
        token1PriceUSD,
        pendingCakeUSD,
        deposited0USD,
        deposited1USD,
        fee0EarnedUSD,
        fee1EarnedUSD,
        cakePriceUSD,
        chain
    } = position;

    // Use ticks for in-range check to avoid floating-point precision issues
    const inRange = currentTick >= tickLower && currentTick <= tickUpper;
    const statusText = inRange ? 'Dentro del Rango' : `Fuera del Rango (${currentTick < tickLower ? 'Por Debajo' : 'Por Encima'})`;

    // For the bar: extend to include current if outside
    const minTick = Math.min(tickLower, tickUpper, currentTick);
    const maxTick = Math.max(tickLower, tickUpper, currentTick);
    const tickRange = maxTick - minTick || 1; // Avoid division by zero

    // Positions as %
    const lowerPos = ((tickLower - minTick) / tickRange) * 100;
    const upperPos = ((tickUpper - minTick) / tickRange) * 100;
    const currentPos = ((currentTick - minTick) / tickRange) * 100;

    // Inverse prices
    const invPriceLower = priceUpper ? 1 / priceUpper : 0;
    const invPriceUpper = priceLower ? 1 / priceLower : 0;
    const invPriceCurrent = priceCurrent ? 1 / priceCurrent : 0;

    // Calculate totals
    const totalDepositedUSD = deposited0USD + deposited1USD;
    const totalFeesUSD = fee0EarnedUSD + fee1EarnedUSD;

    // Formatter function for USD
    const formatUSD = (num) => num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    return (
        <div className="card position-card h-100 border-0 shadow-lg" style={{ background: 'linear-gradient(180deg, #1a1a1a 0%, #121212 100%)' }}>
            <div className="card-header bg-transparent border-bottom-0 pb-0">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <small className="text-muted me-2">Posición #{tokenId.slice(-6)}</small>
                        <span className={`badge ${chain === 'bsc' ? 'bg-warning text-dark' : 'bg-info text-dark'} me-2`} style={{ fontSize: '0.7rem' }}>
                            {NETWORKS[chain]?.name || chain.toUpperCase()}
                        </span>
                    </div>
                    <span className="badge bg-primary-subtle text-primary">
                        {feeTier / 10000}%
                    </span>
                </div>
            </div>

            <div className="card-body pt-2">
                {/* Símbolos y MasterChef */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0 text-white">{token0Symbol} / {token1Symbol}</h5>
                    <span className={`badge ${isInMasterChef ? 'bg-success' : 'bg-secondary'} rounded-pill`}>
                        {isInMasterChef ? 'En MasterChef' : 'No en MasterChef'}
                    </span>
                </div>

                {/* Valor Total */}
                <div className="d-flex justify-content-between align-items-center mb-4 p-3 rounded" style={{ background: 'rgba(0, 255, 0, 0.1)', border: '1px solid rgba(0, 255, 0, 0.2)' }}>
                    <small className="text-muted fw-bold">Valor Total</small>
                    <div className="fs-3 fw-bold text-success">
                        ${formatUSD(valueUSD)}
                    </div>
                </div>

                {/* Estado del Rango y Barra - Moved here, more prominent */}
                <div className="mb-4 p-3 rounded shadow-sm" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <div className="text-center mb-3">
                        <span className={`fw-bold fs-4 ${inRange ? 'text-success' : 'text-danger'}`}>
                            {statusText}
                        </span>
                    </div>
                    <div className="position-relative bg-dark rounded-pill" style={{ height: '12px' }}>
                        {/* Lower tick - blue line */}
                        <div
                            className="position-absolute bg-primary rounded-pill shadow"
                            style={{ left: `${lowerPos}%`, top: '-6px', height: '24px', width: '6px', transform: 'translateX(-50%)' }}
                        ></div>
                        {/* Upper tick - blue line */}
                        <div
                            className="position-absolute bg-primary rounded-pill shadow"
                            style={{ left: `${upperPos}%`, top: '-6px', height: '24px', width: '6px', transform: 'translateX(-50%)' }}
                        ></div>
                        {/* Current tick - green if in range, red if out */}
                        <div
                            className={`position-absolute ${inRange ? 'bg-success' : 'bg-danger'} rounded-pill shadow`}
                            style={{ left: `${currentPos}%`, top: '-6px', height: '24px', width: '6px', transform: 'translateX(-50%)' }}
                        ></div>
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                        <small className="text-muted fw-bold">LOWER: {tickLower}</small>
                        <small className="text-muted fw-bold">UPPER: {tickUpper}</small>
                    </div>
                    <small className="text-muted d-block text-center mt-1 fw-bold">ACTUAL: {currentTick}</small>
                </div>

                {/* Ganancias Acumuladas (NUEVO) */}
                <div className="mb-4">
                    <div className="p-3 rounded mb-2 shadow-sm" style={{ background: 'rgba(57, 197, 209, 0.1)', border: '1px solid rgba(57, 197, 209, 0.2)' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted fw-bold">Ganancias Totales</small>
                            <div className="fs-4 fw-bold text-info">
                                ${formatUSD(totalFeesUSD + pendingCakeUSD)}
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">
                        <div className="col-6">
                            <div className="p-2 rounded h-100" style={{ background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
                                <small className="text-muted d-block mb-1">Fees Acumulados</small>
                                <div className="fw-bold text-white">${formatUSD(totalFeesUSD)}</div>
                                <div style={{ fontSize: '0.75rem' }} className="text-muted mt-1">
                                    {fee0Earned.toFixed(4)} {token0Symbol} / {fee1Earned.toFixed(4)} {token1Symbol}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="p-2 rounded h-100" style={{ background: 'rgba(255, 255, 255, 0.03)', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
                                <small className="text-muted d-block mb-1">CAKE Pendiente</small>
                                <div className="fw-bold text-white">${formatUSD(pendingCakeUSD)}</div>
                                <div style={{ fontSize: '0.75rem' }} className="text-muted mt-1">
                                    {pendingCake.toFixed(4)} CAKE
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Depositados */}
                <div className="mb-4">
                    <small className="text-muted d-block mb-2 fw-bold">Depositados (${formatUSD(totalDepositedUSD)})</small>
                    <div className="row g-3">
                        <div className="col-6">
                            <small className="text-muted d-block">{token0Symbol}</small>
                            <div className="fw-semibold fs-5 text-white">{deposited0.toFixed(4)}</div>
                            <div className="fw-bold text-success fs-6">${formatUSD(deposited0USD)}</div>
                            <small className="text-muted">1 {token0Symbol} = ${formatUSD(token0PriceUSD)} USD</small>
                        </div>
                        <div className="col-6">
                            <small className="text-muted d-block">{token1Symbol}</small>
                            <div className="fw-semibold fs-5 text-white">{deposited1.toFixed(4)}</div>
                            <div className="fw-bold text-success fs-6">${formatUSD(deposited1USD)}</div>
                            <small className="text-muted">1 {token1Symbol} = ${formatUSD(token1PriceUSD)} USD</small>
                        </div>
                    </div>
                </div>

                {/* Fees Ganados */}
                <div className="mb-4">
                    <small className="text-muted d-block mb-2 fw-bold">Fees Ganados (${formatUSD(totalFeesUSD)})</small>
                    <div className="row g-3">
                        <div className="col-6">
                            <small className="text-muted d-block">{token0Symbol}</small>
                            <div className="fw-semibold fs-5 text-white">{fee0Earned.toFixed(4)}</div>
                            <div className="fw-bold text-success fs-6">${formatUSD(fee0EarnedUSD)}</div>
                            <small className="text-muted">1 {token0Symbol} = ${formatUSD(token0PriceUSD)} USD</small>
                        </div>
                        <div className="col-6">
                            <small className="text-muted d-block">{token1Symbol}</small>
                            <div className="fw-semibold fs-5 text-white">{fee1Earned.toFixed(4)}</div>
                            <div className="fw-bold text-success fs-6">${formatUSD(fee1EarnedUSD)}</div>
                            <small className="text-muted">1 {token1Symbol} = ${formatUSD(token1PriceUSD)} USD</small>
                        </div>
                    </div>
                </div>

                {/* Pending Cake */}
                <div className="mb-4">
                    <small className="text-muted d-block mb-1 fw-bold">CAKE Pendiente</small>
                    <div className="fw-semibold fs-5 text-primary">{pendingCake.toFixed(4)}</div>
                    <div className="fw-bold text-success fs-6">${formatUSD(pendingCakeUSD)}</div>
                    <small className="text-muted">1 CAKE = ${formatUSD(cakePriceUSD)} USD</small>
                </div>

                {/* Precios Bidireccionales (REFRACTORIZADO) */}
                <div className="mb-4">
                    <h6 className="mb-3 fw-bold text-white d-flex align-items-center">
                        <i className="bi bi-graph-up-arrow me-2 text-primary"></i>
                        Rangos y Precios
                    </h6>

                    <div className="row g-2">
                        {/* Token1 por Token0 */}
                        <div className="col-6">
                            <div className="p-2 rounded h-100" style={{ background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
                                <small className="text-muted d-block mb-2 text-center border-bottom border-secondary pb-1">{token1Symbol} / {token0Symbol}</small>
                                <div className="d-flex flex-column gap-1">
                                    <div className="d-flex justify-content-between">
                                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>MAX:</small>
                                        <small className="text-white fw-semibold">{priceUpper.toFixed(6)}</small>
                                    </div>
                                    <div className="d-flex justify-content-between p-1 rounded" style={{ background: 'rgba(57, 197, 209, 0.1)' }}>
                                        <small className="text-info fw-bold" style={{ fontSize: '0.7rem' }}>ACTUAL:</small>
                                        <small className="text-info fw-bold">{priceCurrent.toFixed(6)}</small>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>MIN:</small>
                                        <small className="text-white fw-semibold">{priceLower.toFixed(6)}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Token0 por Token1 (Inverso) */}
                        <div className="col-6">
                            <div className="p-2 rounded h-100" style={{ background: 'rgba(255, 255, 255, 0.02)', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
                                <small className="text-muted d-block mb-2 text-center border-bottom border-secondary pb-1">{token0Symbol} / {token1Symbol}</small>
                                <div className="d-flex flex-column gap-1">
                                    <div className="d-flex justify-content-between">
                                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>MAX:</small>
                                        <small className="text-white fw-semibold">{invPriceUpper.toFixed(6)}</small>
                                    </div>
                                    <div className="d-flex justify-content-between p-1 rounded" style={{ background: 'rgba(57, 197, 209, 0.1)' }}>
                                        <small className="text-info fw-bold" style={{ fontSize: '0.7rem' }}>ACTUAL:</small>
                                        <small className="text-info fw-bold">{invPriceCurrent.toFixed(6)}</small>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <small className="text-muted" style={{ fontSize: '0.7rem' }}>MIN:</small>
                                        <small className="text-white fw-semibold">{invPriceLower.toFixed(6)}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-3">
                    <small className="text-muted d-block mb-1 fw-bold">Direcciones</small>
                    <div className="d-flex justify-content-between align-items-center">
                        <a href={`${NETWORKS[chain]?.explorer}/address/${token0}`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            <small className="text-primary">{token0.slice(0, 6)}...{token0.slice(-4)}</small>
                        </a>
                        <small className="text-muted mx-2">/</small>
                        <a href={`${NETWORKS[chain]?.explorer}/address/${token1}`} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            <small className="text-primary">{token1.slice(0, 6)}...{token1.slice(-4)}</small>
                        </a>
                    </div>
                </div>

                {/* Liquidez - Menos protagonismo */}
                <div className="text-center">
                    <small className="text-muted">Liquidez: {liquidity.toLocaleString()}</small>
                </div>
            </div>
        </div>
    );
};

export default PositionCard;